/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, suggested: NonNullable<unknown> }} Sanction_Escalation_HintInputs */



/**
* | output |
* | --- |
* | "{count} prior offence(s) of this type — suggested level: {suggested}" |
*
* @param {Sanction_Escalation_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_escalation_hint = /** @type {((inputs: Sanction_Escalation_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Escalation_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} infraction(s) antérieure(s) de ce type — niveau suggéré : ${i?.suggested}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} infracción/es anterior/es de este tipo — nivel sugerido: ${i?.suggested}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`${i?.count} infração/ões anterior/es deste tipo — nível sugerido: ${i?.suggested}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} infrazione/i precedente/i di questo tipo — livello suggerito: ${i?.suggested}`)
	return /** @type {LocalizedString} */ (`${i?.count} prior offence(s) of this type — suggested level: ${i?.suggested}`)
});